import { createContext, ReactNode, useEffect, useState } from "react";
import { parSpunte } from "../../../networking";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

export type FormCheckedServices = {
  numPrenotazione: string;
  spunta: boolean;
  paziente: string;
  specialita: string | null;
  prestazione: string | null;
  medico: string | null;
  dallaData: string;
  allaData: string;
  periodoDiCompetenza: string;
};

type CheckedServicesContextType = {
  colonne: any;
  setColonne: (data: any) => void;
  dataSpunteParams: any;
  setDataSpunteParams: (data: any) => void;
  records: any;
  setRecords: (data: any) => void;
  loadingDataSpunte: boolean | null;
  setLoadingDataSpunte: (data: boolean | null) => void;
  handleResetFieldsCallBack: any;
  setHandleResetFieldsCallBack: any;
  methodsFormCheckedServices: any;
};

const CheckedServicesContext = createContext<
  CheckedServicesContextType | undefined
>(undefined);

const CheckedServicesContextWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [colonne, setColonne] = useState<any>([]);
  const [records, setRecords] = useState<any>([]);
  const [loadingDataSpunte, setLoadingDataSpunte] = useState<boolean | null>(
    null
  );
  const [dataSpunteParams, setDataSpunteParams] = useState<any>(null);
  const [handleResetFieldsCallBack, setHandleResetFieldsCallBack] =
    useState<any>(null);

  useEffect(() => {
    if (dataSpunteParams?.dati) {
      methodsFormCheckedServices.reset({
        ...methodsFormCheckedServices.getValues(),
        dallaData: dayjs(dataSpunteParams?.dati?.dataInizio).format(),
        allaData: dayjs(dataSpunteParams?.dati?.dataFine).format(),
      });
    }
  }, [dataSpunteParams]);

  const methodsFormCheckedServices = useForm<FormCheckedServices>({
    defaultValues: {
      numPrenotazione: "",
      spunta: false,
      paziente: "",
      specialita: null,
      prestazione: null,
      medico: null,
      dallaData:
        dayjs().format(),
      allaData:
        dayjs().format(),
      periodoDiCompetenza: "",
    },
  });

  useEffect(() => {
    requestParSpunteParams();
  }, []);

  useEffect(() => {
    console.log("columns:", colonne);
    console.log("records:", records);
  }, [colonne, records]);

  const requestParSpunteParams = async () => {
    try {
      const payload: any = {
        // opzionale
        aziendaPrenotazione: "MEDITEL",
      };

      const response: any = await parSpunte(payload);

      console.log("Risposta dal server:", response);

      setDataSpunteParams(response.data);

      // if (response.data[0].esito === "OK") {
      //   setSeverity("success");
      // } else {
      //   setSeverity("error");
      // }
      // setMessage(response.data[0].messaggio);
    } catch (err) {
      console.error("Errore fetch datiPacada:", err);
    } finally {
      // setShowAllert(true);
    }
  };

  const props = {
    colonne,
    setColonne,
    records,
    setRecords,
    dataSpunteParams,
    setDataSpunteParams,
    loadingDataSpunte,
    setLoadingDataSpunte,
    handleResetFieldsCallBack,
    setHandleResetFieldsCallBack,
    methodsFormCheckedServices,
  };

  return (
    <CheckedServicesContext.Provider value={props}>
      {children}
    </CheckedServicesContext.Provider>
  );
};

export { CheckedServicesContextWrapper, CheckedServicesContext };
